const STATUS_MAP = {
  CONFIRMADO: 'confirmado',
  CHECKIN: 'confirmado',
  ATENDENDO: 'confirmado',
  FINALIZADO: 'confirmado',
  CANCELADO: 'cancelado',
  "ORÇAMENTO ENVIADO": 'finalizado',
}

const STATUS_OVERLAP = [
  "CANCELADO",
  "ORÇAMENTO ENVIADO"
]


function secondsToTime(seconds) {
  const parsedSeconds = Number(seconds) || 0
  const hours = Math.floor(parsedSeconds / 3600).toString().padStart(2, '0')
  const minutes = Math.floor((parsedSeconds % 3600) / 60).toString().padStart(2, '0')

  return `${hours}:${minutes}`
}

function splitServices(serviceName) {
  if (!serviceName) return []
  if (Array.isArray(serviceName)) return serviceName.filter(Boolean)

  return serviceName
    .split(' | ')
    .map(service => service.trim())
    .filter(Boolean)
}

function buildSuggestions({ isSubscriber, services }) {
  const suggestions = [
    isSubscriber
      ? { tipo: 'assinante', mensagem: 'Cliente já é assinante.' }
      : {
        tipo: 'oferta_assinatura',
        mensagem: 'Cliente ainda não é assinante. Apresente os planos durante o atendimento.',
      },
  ]
  const serviceNames = services.join(' ').toUpperCase()

  if (serviceNames.includes('BANHO') && !serviceNames.includes('HIDRAT')) {
    suggestions.push({
      tipo: 'servico_complementar',
      mensagem: 'Banho agendado. Verifique o histórico de hidratação do pet.',
    })
  }

  return suggestions
}

function normalizeAttributeLabel(label = '') {
  return label
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

function getPetAttribute(attributes = [], label) {
  const normalizedLabel = normalizeAttributeLabel(label)
  return attributes.find(attribute =>
    normalizeAttributeLabel(attribute.attributeLabel) === normalizedLabel
  )?.value || null
}

function normalizePetSex(sex) {
  const normalizedSex = normalizeAttributeLabel(sex)
  if (['f', 'femea'].includes(normalizedSex)) return 'F'
  if (['m', 'macho'].includes(normalizedSex)) return 'M'
  return sex || null
}


function getStatus(appointment, appointmentServices, callbackStatus) {
  const appointmentStatus = appointment.status || appointmentServices[0]?.status

  if (STATUS_OVERLAP.includes(appointmentStatus)) return STATUS_MAP[appointmentStatus]

  return appointment.contactStatus || STATUS_MAP[appointmentStatus] || callbackStatus
}

function getAppointmentPrice(appointment, appointmentServices) {
  if (appointmentServices.length) {
    return appointmentServices.reduce((total, service) => {
      const price = !service.subscriptionStatus ? Number(service.totalPrice) : 0
      return total + price
    }, 0)
  }
  if (appointment.subscriber) return 0
  return Number(appointment.totalPrice)

}

export function formatAgendaAppointment(appointment = {}, context = {}) {
  const appointmentServices = Array.isArray(appointment.services)
    ? appointment.services
    : []
  const customer = appointment.customer || {}
  const pet = appointment.pet || {}
  const services = appointmentServices.length
    ? appointmentServices.map(service => service.name).filter(Boolean)
    : splitServices(appointment.serviceName)
  const serviceIds = appointmentServices
    .map(service => service.serviceOrderId || service.id)
    .filter(Boolean)
  const employees = [...new Set(
    appointmentServices
      .map(service => service.employee?.name)
      .filter(Boolean)
  )]

  const appointmentId =
    appointment.appointmentId ||
    appointment.id ||
    appointment.appointmentOrderId ||
    appointment.serviceOrderId ||
    serviceIds[0] ||
    [customer.id, pet.id, context.date, appointment.startsAt]
      .filter(Boolean)
      .join('-')

  const isSubscriber = !!appointment.subscriber

  return {
    appointmentId,
    appointmentOrderId: appointment.appointmentOrderId || appointment.serviceOrderId || null,
    horario: secondsToTime(appointment.startsAt),
    status: getStatus(appointment, appointmentServices, 'pendente'),
    department: appointment.department || context.department || 'Banho e Tosa',
    servicos: services,
    servicosCompletos: services,
    profissional: appointment.employeeName || employees.join(', ') || null,
    data: appointment.appointmentDate || context.date || null,
    valor: getAppointmentPrice(appointment, appointmentServices),
    isPackage: appointmentServices.length
      ? appointmentServices.some(service => Boolean(service.hasPackage))
      : Boolean(appointment.isPackage),
    isRecurring: Boolean(appointment.isRecurring),
    confirmedByStore: Boolean(appointment.confirmedByStore),
    comment: appointment.comment || '',
    petComments: pet.comments || appointment.petComments || '',
    contacted: Boolean(appointment.contacted),
    // Confirmação por WhatsApp. Este formatResponse é whitelist explícita, então
    // o campo precisa ser listado — sem isto ele é descartado silenciosamente.
    confirmation: appointment.confirmation || null,
    assinante: isSubscriber,
    package: appointment.package || false,
    cliente: {
      customerId: customer.id || appointment.customerId || null,
      nome: [customer.firstname, customer.lastname].filter(Boolean).join(' ') ||
        appointment.customerName ||
        'Não informado',
      telefone: customer.cellphone ||
        customer.telephone ||
        appointment.phone ||
        null,
      cpf: customer.cpf || appointment.customerCpf || null,
      primeiroAtendimento: false,
    },
    pet: {
      petId: pet.id || appointment.petId || null,
      nome: pet.petName || appointment.petName || 'Não informado',
      raca: getPetAttribute(pet.attributes, 'Raça') || appointment.petBreed || null,
      porte: getPetAttribute(pet.attributes, 'Porte') || appointment.petSize || null,
      pelagem: getPetAttribute(pet.attributes, 'Pelagem') || appointment.petCoat || null,
      sexo: normalizePetSex(
        getPetAttribute(pet.attributes, 'Sexo') || appointment.petSex
      ),
    },
    sugestoes: buildSuggestions({ isSubscriber, services }),
  }
}

export function buildAgendaSummary(appointments = []) {
  return {
    total: appointments.length,
    assinantes: appointments.filter(item => item.cliente.assinante).length,
    novosClientes: appointments.filter(item => item.cliente.primeiroAtendimento).length,
    confirmados: appointments.filter(item => ['CONFIRMADO', 'CHECKIN'].includes(item.status)).length,
  }
}

export function formatServiceHistory(data) {
  return Array.isArray(data) ? data : []
}

export function formatPurchaseHistory(data) {
  if (Array.isArray(data?.historicoCompras)) return data.historicoCompras
  return Array.isArray(data) ? data : []
}

export function getAgendaContactStatus(contactStatus = {}, appointment = {}) {
  return contactStatus[appointment.appointmentId] ?? STATUS_MAP[appointment.status] ?? 'pendente'
}
